var map = {
	"./american-express.svg": "bc31",
	"./discover.svg": "d55b",
	"./logo.png": "1d17",
	"./mastercard.svg": "b360",
	"./mng-logo-mob.png": "6f82",
	"./mng_logo.png": "2e86",
	"./paypal.svg": "165f",
	"./visa.svg": "ff3b",
	"./wave1.png": "9f04",
	"./wave2.png": "3db0",
	"./wave3.png": "9bbe"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "be5c";